import { ReactNode, useMemo } from "react";
import { SideBarContainer } from "../../../../../../../../../components/SideBarContainer";
import { ImpoundsTabs } from "../components";

type TOpenSidebar = {
  id: string | null;
  setId: React.Dispatch<React.SetStateAction<string | null>>;
  reloadData: () => void;
  payeesNumber: {
    primaryBuyerNumber: number;
    primarySellerNumber: number;
  };
  activeKey: string;
  customSidebarClass: string;
  parentId: string;
  isDistributionModalOpen: boolean;
  setIsDistributionModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  sidebarIsOpen: boolean;
  setSidebarIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const useOpenSidebar = ({
  id,
  setId,
  reloadData,
  payeesNumber,
  activeKey,
  customSidebarClass,
  parentId,
  isDistributionModalOpen,
  setIsDistributionModalOpen,
  sidebarIsOpen,
  setSidebarIsOpen
}: TOpenSidebar) => {
  const formWrapper: ReactNode = useMemo(() => {
    if (!sidebarIsOpen) {
      return null;
    }

    const formTitle = id !== null ? `Impound Details` : `Add Impound`;

    return (
      <SideBarContainer
        title={formTitle}
        setShowSideBar={setSidebarIsOpen}
        setCurrentId={setId}
        customClass={customSidebarClass}
      >
        <ImpoundsTabs
          id={id}
          reloadData={reloadData}
          setIsOpen={setSidebarIsOpen}
          setId={setId}
          parentId={parentId}
          payeesNumber={payeesNumber}
          activeKey={activeKey}
          isDistributionModalOpen={isDistributionModalOpen}
          setIsDistributionModalOpen={setIsDistributionModalOpen}
        />
      </SideBarContainer>
    );
  }, [
    sidebarIsOpen,
    id,
    setSidebarIsOpen,
    setId,
    customSidebarClass,
    reloadData,
    parentId,
    payeesNumber,
    activeKey,
    isDistributionModalOpen,
    setIsDistributionModalOpen
  ]);

  return { formWrapper, isOpen: sidebarIsOpen, setIsOpen: setSidebarIsOpen };
};
